import { API } from "./api";

export function formatIDR(n) {
  if (n === 0 || n === null || n === undefined) return "Gratis";
  return "Rp " + Number(n).toLocaleString("id-ID");
}

export function mediaUrl(val) {
  if (!val) return "";
  if (typeof val === "string" && (val.startsWith("http") || val.startsWith("data:"))) return val;
  return `${API}/media/${val}`;
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export const PRODUCT_TYPES = [
  { value: "APPLICATION", label: "Aplikasi" },
  { value: "SOURCE_CODE", label: "Source Code" },
  { value: "TEMPLATE", label: "Template" },
  { value: "SCRIPT", label: "Script" },
];

export const typeLabel = (t) => PRODUCT_TYPES.find((x) => x.value === t)?.label || t;
